<template>
  <div :style="bannerStyle" :class="['banner', bannerClass(banner.status), banner.class]" v-if="banner.isShow">
    <div class="d-flex align-items-center"><b>{{ banner.text }}</b></div>
  </div>
</template>

<script>

export default {
  name: 'Banner',
  props: {
    banner: {
      type: Object,
      required: true
    }
  },
  computed: {
    bannerStyle() {
      return {
        bottom: this.banner.isShow ? '0' : '-10rem'
      };
    }
  },
  methods: {
    bannerClass(status) {
      switch (status) {
        case 'success':
          return 'success-banner';
        case 'danger':
          return 'danger-banner';
        default:
          return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  font-size: 1em;
  left: 0rem;
  width: calc(100vw - 9rem);
  transition: 1s;
  padding: 0 7rem;
  height: 4.5rem;
  z-index: 102;
  width: 100vw;
}

.success-banner {
  background: #E5FFEC;
  color: #4F4F4F;
}

.danger-banner {
  background: #FFCFCF;
  color: #4F4F4F;
}
</style>
